// Generated by Melange

import * as Buhta_cabinet__Btn from "../../html/Btn.js";
import * as Buhta_cabinet__Field from "../../html/Field.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ManageProductModal(Props) {
  let onClose = Props.onClose;
  const match = React.useState(function () {
        return "";
      });
  const setArticle = match[1];
  const match$1 = React.useState(function () {
        return "";
      });
  const setName = match$1[1];
  const match$2 = React.useState(function () {
        return "";
      });
  const setUnit = match$2[1];
  const match$3 = React.useState(function () {
        return "";
      });
  const setTax = match$3[1];
  const match$4 = React.useState(function () {
        return "";
      });
  const setPrice = match$4[1];
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                    children: "Новый товар или услуга"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-6 h-6",
                                          src: StaticAsset.src("/static/icons/close.svg")
                                        }),
                                    onClick: onClose
                                  })
                            ],
                            className: "px-6 py-4 flex justify-between items-center"
                          }),
                      JsxRuntime.jsx("hr", {}),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                    label: "Артикул",
                                    type_: "text",
                                    name: "article",
                                    required: true,
                                    onChange: (function (value) {
                                        Curry._1(setArticle, (function (param) {
                                                return value;
                                              }));
                                      }),
                                    value: match[0]
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                    label: "Название",
                                    type_: "text",
                                    name: "name",
                                    required: true,
                                    onChange: (function (value) {
                                        Curry._1(setName, (function (param) {
                                                return value;
                                              }));
                                      }),
                                    className: "mt-4",
                                    value: match$1[0]
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                    label: "Ед. измерения",
                                    type_: "text",
                                    name: "unit",
                                    required: true,
                                    onChange: (function (value) {
                                        Curry._1(setUnit, (function (param) {
                                                return value;
                                              }));
                                      }),
                                    className: "mt-4",
                                    value: match$2[0]
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                    label: "Налог",
                                    type_: "text",
                                    name: "tax",
                                    required: true,
                                    onChange: (function (value) {
                                        Curry._1(setTax, (function (param) {
                                                return value;
                                              }));
                                      }),
                                    className: "mt-4",
                                    value: match$3[0]
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                    label: "Цена",
                                    type_: "text",
                                    name: "price",
                                    required: true,
                                    onChange: (function (value) {
                                        Curry._1(setPrice, (function (param) {
                                                return value;
                                              }));
                                      }),
                                    className: "mt-4",
                                    value: match$4[0]
                                  })
                            ],
                            className: "px-6 py-8"
                          }),
                      JsxRuntime.jsx("hr", {}),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                  title: "Сохранить",
                                  className: "px-4 py-2",
                                  text: /* He5 */1
                                }),
                            className: "px-6 py-3 flex justify-end"
                          })
                    ],
                    className: "w-156 bg-white rounded-md shadow-payroll",
                    onClick: (function (ev) {
                        ev.stopPropagation();
                      })
                  }),
              className: "absolute inset-0 bg-black/24 flex justify-center items-center",
              onClick: onClose
            });
}

const make = ManageProductModal;

export {
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
